import { CurriculumServiceFirestore } from "./CurriculumServiceFirestore";
import { CurriculumServiceLocal } from "./CurriculumServiceLocal";
export class CurriculumServiceFactory {
    static createLocal() {
        return new CurriculumServiceLocal();
    }
    static createFirestore(firestore) {
        if (!firestore) {
            throw new Error("Firestore instance is required for Firebase service");
        }
        return new CurriculumServiceFirestore(firestore);
    }
}
